import {Component, OnDestroy, OnInit} from '@angular/core';
import {ToasterModule, ToasterService, ToasterConfig} from 'angular2-toaster/angular2-toaster';
import {Router, ActivatedRoute, NavigationStart, NavigationEnd, NavigationError, RouteConfigLoadStart, RouteConfigLoadEnd,} from '@angular/router';
import {AuthenticationService} from './services/authentication.service';
import {Location} from '@angular/common';
import {Observable} from 'rxjs/Rx';
import {NgxSpinnerService} from "ngx-spinner";
import { HelperService } from "./services/helper.service";
import { IdleService } from "./services/idle.service";

@Component({
    // tslint:disable-next-line
    selector: 'body',
    templateUrl: './app.component.html',
    providers: [AuthenticationService]
})
export class AppComponent  implements OnInit{
    private toasterService: ToasterService;
    private navigationMenuID: number;
    navigationSubscription;
    isLogin: any;
    public toasterconfig: ToasterConfig =
    new ToasterConfig({
      tapToDismiss: true,
      timeout: 5000
    });
    private cssFile = "assets/index-Ddf2EaXc.css";
    private linkId = "dynamic-style";

    constructor(toasterService: ToasterService, private router: Router, private location: Location,  private helperService: HelperService,
                private route: ActivatedRoute, private authenticationService: AuthenticationService,private spinner: NgxSpinnerService, private idleService: IdleService) {
        
        this.idleService.startWatching(() => this.logout());
        
        this.toasterService = toasterService;
        this.isLogin = Observable.interval(9000)
            .subscribe(x => {
                if (localStorage.getItem('access_token') || localStorage.getItem('refresh_token')) {
                    //this.checkUser();
                }

            });
        var that = this;
        /*this.router.routeReuseStrategy.shouldReuseRoute = function () {
         return false;
         };*/

        /*this.router.events.subscribe((evt) => {
         if (evt instanceof NavigationEnd) {
         // trick the Router into believing it's last link wasn't previously loaded
         //this.router.navigated = false;
         // if you need to scroll back to top, here is the right place
         //window.scrollTo(0, 0);
         }
         });*/
 this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.spinner.show();  // show spinner when lazy loading starts
      } else if (event instanceof RouteConfigLoadEnd) {
        this.spinner.hide();  // hide spinner when lazy loading ends
      }
    });

         const urlParams = new URLSearchParams(window.location.search);
         console.log(urlParams);
         // Check if the 'token' parameter exists
         const access_token = urlParams.get("access_token");
         const refresh_token = urlParams.get("refresh_token");
         const selectedCompany = urlParams.get("selectedCompany");
     
         console.log(access_token);
         if (access_token) {
             // Store the token in sessionStorage
             sessionStorage.setItem("access_token", access_token);
             sessionStorage.setItem("refresh_token", refresh_token);
             sessionStorage.setItem("selectedCompany", selectedCompany);
             // Store the token in localStorage
             localStorage.setItem("access_token", access_token);
             localStorage.setItem("refresh_token", refresh_token);
             localStorage.setItem("selectedCompany", selectedCompany);
     
             this.helperService.go('home');
        } 
     

        this.router.events
            .filter(e => e.constructor.name === 'RoutesRecognized')
            .pairwise()
            .subscribe((e: any[]) => {
                var nextState = e[1].urlAfterRedirects;
                var pairwiseState = e[0].urlAfterRedirects;
                if (pairwiseState.indexOf('-edit') == -1 && nextState.indexOf('-edit') == -1) {
                    var keys = Object.keys(localStorage), i = keys.length;
                    while (i--) {
                        if (keys[i].indexOf('DataTables_') >= 0) {
                            localStorage.removeItem(keys[i]);
                        }
                    }

                    var keys2 = Object.keys(sessionStorage), z = keys2.length;
                    while (z--) {
                        if (keys2[z].indexOf('DataTables_') >= 0) {
                            sessionStorage.removeItem(keys2[z]);
                        }
                    }
                }
            });



            router.events.subscribe(event => {
                if(event instanceof NavigationStart) {
                  this.spinner.show();
                  console.log("event started")
                }else if(event instanceof NavigationEnd) {
                    this.spinner.hide();
                  console.log("event end")
                }
                // NavigationEnd
                // NavigationCancel
                // NavigationError
                // RoutesRecognized
              });



        /*this.router.events.subscribe((event) => {
         if (event instanceof NavigationStart) {
         console.log('Router event start:', event);
         }

         if (event instanceof NavigationEnd) {
         console.log('Router event:', event);
         }
         if (event instanceof NavigationError) {
         }
         });*/

        /* router.events
         .filter(e => e instanceof NavigationEnd)
         .forEach(e => {
         this.navigationMenuID = this.route.children[0].children[0].data._value.id;
         this.checkUserGroupAccessRights();
         });*/
    }


    ngOnInit() {
        this.router.events.subscribe(event => {
          if (event instanceof NavigationEnd) {
            this.updateStylesheet(event.urlAfterRedirects);
          }
        });



    
        // Initial check on load
        this.updateStylesheet(window.location.href);
      }
    
      private updateStylesheet(url: string) {
        if (url.includes("workflow")) {
          // Add the CSS file if not already added
          if (!document.getElementById(this.linkId)) {
            let link = document.createElement("link");
            link.id = this.linkId;
            link.rel = "stylesheet";
            link.href = this.cssFile;
            document.head.appendChild(link);
            console.log("Before removing:", sessionStorage.getItem('reloaded'));
           // sessionStorage.removeItem('reloaded');
            console.log("After removing:", sessionStorage.getItem('reloaded'));

          }
        } else {
          // Remove the CSS file if it exists
          let existingLink = document.getElementById(this.linkId);
          if (existingLink) {
            existingLink.remove();
            console.log("Before removing:", sessionStorage.getItem('reloaded'));
            sessionStorage.removeItem('reloaded');
            console.log("After removing:", sessionStorage.getItem('reloaded'));
          }
        }
      }

    /*ngOnDestroy() {
     // avoid memory leaks here by cleaning up after ourselves. If we
     // don't then we will continue to run our initialiseInvites()
     // method on every navigationEnd event.
     if (this.navigationSubscription) {
     this.navigationSubscription.unsubscribe();
     }
     }*/

    refreshToken() {
        this.authenticationService.refreshToken()
            .subscribe(
                data => {
                },
                error => {
                    this.authenticationService.logout();
                });
    }

    checkUser() {
        this.authenticationService
            .checkAuth()
            .get()
            .subscribe(resp => {

            }, (error) => {
                if (localStorage.getItem('refresh_token')) {
                    this.refreshToken();
                } else {
                    this.authenticationService.logout();
                }
            });
    }


       logout() {
        this.authenticationService.logout();
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(['/login']);
    }

}



// WEBPACK FOOTER //
// /app/src/app/app.component.ts